import styled from 'styled-components';

export const Content = styled.div`
  /* padding: 15px 0 0; */
  margin: 0 0 0 20px;
  select {
    /* max-width: 100%; */
    /* width: auto; */
    max-width: 280px;
    font-size: 15px;
    color: #000;
    border-radius: 4px;
    border: solid 1px #bebebe;
    height: 30px;
    padding: 3px;
  }
`;
